import {
    AccountSortField as AccountSortFields,
} from 'src/openapi/admin/models/AccountSortField';

import {COLUMNS, LOADING_PRIORITY} from './constants';

import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';

export const checkShouldLoadColumn = (columnId: string, selectedColumns: string[]) => {
    const relation = LOADING_PRIORITY.find(rel => rel.columnId === columnId);
    if (!relation) {
        return false;
    }

    return !LOADING_PRIORITY
        .filter(column => selectedColumns.includes(column.columnId))
        .some(other => (
            other.columnId !== columnId &&
            other.chunk === relation.chunk &&
            other.priority > relation.priority
        ));
};

export const mapColumnIdToAccountSortField: (columnId: string) => AccountSortField = columnId => {
    switch (columnId) {
        case COLUMNS.ACCOUNT_NAME:
            return AccountSortFields.ACCOUNT_NAME;
        case COLUMNS.ACCOUNT_STATUS:
            return AccountSortFields.ACCOUNT_STATUS;
        case COLUMNS.PRIMARY_ACCOUNT_MANAGER:
            return AccountSortFields.PRIMARY_ACCOUNT_MANAGER;
        case COLUMNS.LICENSE_TYPE:
            return AccountSortFields.LICENSE_TYPE;
        case COLUMNS.LICENSE_END_DATE:
            return AccountSortFields.LICENSE_END_DATE;
        default:
            return AccountSortFields.ACCOUNT_NAME;
    }
};

